import React from 'react';
import { Link } from 'react-router-dom';
import { siteData } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const { hero, specializations, stats } = siteData;

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen bg-gradient-to-b from-[#e8f5f0] to-[#daf0e8] pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            {/* Logo and Brand */}
            <div className="flex items-center gap-4">
              <img 
                src={siteData.brand.logo} 
                alt={siteData.brand.name}
                className="h-20 w-auto"
              />
              <div>
                <h1 className="text-4xl lg:text-5xl font-serif text-[#205781] font-light tracking-wide">
                  {hero.title}
                </h1>
                <p className="text-[#205781] text-sm tracking-[0.3em] mt-1 font-medium">
                  {hero.subtitle}
                </p>
              </div>
            </div>

            {/* Main Heading */}
            <h2 className="text-3xl lg:text-4xl font-serif text-[#205781] italic font-light">
              {hero.heading}
            </h2>

            {/* Description */}
            <p className="text-[#205781]/80 text-lg leading-relaxed">
              {hero.description}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              <Link
                to="/book-consultation"
                className="flex items-center gap-2 bg-[#205781] text-white px-8 py-4 rounded-md font-semibold hover:bg-[#1a4666] transition-all duration-300 group"
              >
                {hero.primaryCta.toUpperCase()}
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
              <button
                onClick={() => scrollToSection('#services')}
                className="bg-white/90 text-[#205781] px-8 py-4 rounded-md font-semibold hover:bg-white transition-all duration-300 border border-[#205781]/20"
              >
                {hero.secondaryCta.toUpperCase()}
              </button>
            </div>

            {/* Specializations */}
            <div>
              <p className="text-[#205781] font-semibold mb-3">We Specialize in Managing:</p>
              <div className="flex flex-wrap gap-2">
                {specializations.map((spec, index) => (
                  <span
                    key={index}
                    className="bg-white/70 text-[#205781] px-4 py-2 rounded-full text-sm border border-[#205781]/10"
                  >
                    {spec}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={hero.image}
                alt="Wellness and Healing"
                className="w-full h-[500px] lg:h-[600px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="bg-white/60 py-12 mt-8">
        <div className="max-w-5xl mx-auto px-4">
          <div className="grid grid-cols-3 gap-8 text-center">
            {stats.map((stat, index) => (
              <div key={index} className="space-y-2">
                <p className="text-4xl lg:text-5xl font-serif text-[#205781] italic font-light">
                  {stat.value}
                </p>
                <p className="text-[#205781]/70 text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
